import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { SccPressable } from '@/components/SccPressable';
import { usePlaceDetailScreenName } from '@/hooks/useFeatureFlags';
import useNavigation from '@/navigation/useNavigation';
import dayjs from 'dayjs';
import React from 'react';
import { Text } from 'react-native';
export default function ConqueredPlaceItem({ p }) {
    var _a, _b;
    const navigation = useNavigation();
    const pdpScreen = usePlaceDetailScreenName();
    return (_jsxs(SccPressable, { className: "p-5 border-b-[1px] border-b-gray-20", elementName: "conquered_place_item", logParams: { place_id: p.place.id }, onPress: () => navigation.navigate(pdpScreen, {
            placeInfo: { placeId: p.place.id },
        }), children: [_jsx(Text, { className: "text-[16px] font-pretendard-semibold text-black mb-1", children: p.place.name }), _jsx(Text, { className: "text-[14px] text-gray-50 mb-1", children: p.place.address }), _jsx(Text, { className: "text-[12px] text-gray-50", children: dayjs((_b = (_a = p.accessibilityInfo) === null || _a === void 0 ? void 0 : _a.createdAt) === null || _b === void 0 ? void 0 : _b.value).format('YYYY.MM.DD') })] }, p.place.id));
}
